import React from "react";
import { Box } from "@mui/material";
import { humanize } from "../../utils/adminFormat";

// One status colour map for every admin page (design item 12).
const TONES = {
  green: { bg: "#DCFCE7", fg: "#15803D" },
  amber: { bg: "#FEF3C7", fg: "#B45309" },
  red: { bg: "#FEE2E2", fg: "#B91C1C" },
  blue: { bg: "#E0F2FE", fg: "#0369A1" },
  grey: { bg: "#F3F4F6", fg: "#374151" },
  purple: { bg: "#EDE9FE", fg: "#3B2A9F" },
};

const WORDS = {
  green: ["paid", "active", "approved", "completed", "complete", "clean", "passed", "succeeded", "success", "verified", "published", "resolved", "yes"],
  amber: ["trial", "trialing", "pending", "new", "processing", "in_progress", "in progress", "open", "review", "waiting", "free"],
  red: ["failed", "expired", "rejected", "cancelled", "canceled", "past_due", "unpaid", "requires_payment_method", "blocked", "flagged", "error", "no"],
  blue: ["info", "refunded", "partially_refunded", "sent", "scheduled"],
  grey: ["draft", "inactive", "no plan", "none", "closed", "archived", "unknown"],
};

export function statusTone(status) {
  const key = String(status ?? "").trim().toLowerCase();
  return Object.keys(WORDS).find((tone) => WORDS[tone].includes(key)) || "grey";
}

/** Soft pill chip. `tone` overrides the word map; `label` overrides the text. */
export default function StatusChip({ status, label, tone, sx }) {
  const t = TONES[tone || statusTone(status)] || TONES.grey;
  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        px: 1.25,
        py: "3px",
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.4,
        whiteSpace: "nowrap",
        background: t.bg,
        color: t.fg,
        ...sx,
      }}
    >
      {label ?? humanize(status)}
    </Box>
  );
}

export { TONES as STATUS_TONES };
